import React from 'react';
import { MarkerF } from '@react-google-maps/api';
import { useColorModeValue } from '@chakra-ui/react'; // Import useColorModeValue

function SubLocationMarker({ position, onClick, sublocation, showLabels }) {
  const labelColor = useColorModeValue(
    '#3B2E1E', // Light mode: map.text (Cartographer Ink) or similar
    '#FFFFFF'  // Dark mode: White for high contrast
  );

  if (!position) {
    console.error('[SubLocationMarker] Invalid or missing position for sublocation:', sublocation);
    return null;
  }
  
  // Ensure sublocation and sublocation.name exist before trying to access them for the label
  const labelText = sublocation?.name || '';

  return (
    <MarkerF
      position={position}
      onClick={() => onClick?.(sublocation)}
      icon={{
        url: '/marker-sub.svg', // Distinct icon for sublocations
        scaledSize: new window.google.maps.Size(30, 30), // Potentially smaller than main site markers
        anchor: new window.google.maps.Point(15, 15), // Adjust anchor if needed for the new size/shape
        labelOrigin: new window.google.maps.Point(15, -8) // Adjust label origin
      }}
      title={labelText} // Show name on hover
      label={showLabels && labelText ? {
        text: labelText,
        color: labelColor,
        fontSize: '12px', // Slightly smaller font for sublocations
        fontWeight: 'normal', // Less emphasis than main site names
        className: 'marker-label sublocation-label' // Add specific class for sublocation labels
      } : null}
    />
  );
}

export default React.memo(SubLocationMarker);
